/**
 * @function getImgByLabel
 * @description Searches for the label "PLP" in the array of image objects and returns the URL if found.
 * If no such label is found, returns the URL of the first object in the array.
 * @param {Array<{url: string, label: string, __typename: string}>} images - The array of image objects.
 * @returns {string} The URL of the image with the label "PLP", or the URL of the first image if "PLP" is not found, or an empty string if the array is empty.
 */
function getImgByLabel(images: Array<{ url: string; label: string; __typename: string }>): string {
  if (!Array.isArray(images) || images.length === 0) {
    return '';
  }

  const foundImage = images.find((image) => image.label === 'PLP');
  return foundImage?.url ?? images[0].url ?? '';
}

export default getImgByLabel;
